/** Canonical US legal pages on the marketing site (single source of truth). */
export const LEGAL_PRIVACY_URL = "https://medconcil.com/privacy";
export const LEGAL_TERMS_URL = "https://medconcil.com/terms";
export const LEGAL_COOKIES_URL = "https://medconcil.com/cookies";
